import { toInteger as f } from "./toInteger.js";
function n(r, e) {
  if (r = f(r), r < 1 || !Number.isSafeInteger(r)) return [];
  var o = new Array(r);
  for (var t = 0; t < r; t++) o[t] = typeof e == "function" ? e(t) : t;
  return o;
}
export { n as times };